<template>
  <div>
    <v-row>
      <v-col cols="12" v-if="!$vuetify.breakpoint.xsOnly">
        <v-row no-gutters>
          <v-col cols="9">
            <v-row no-gutters>
              <v-col cols="4" v-if="!$vuetify.breakpoint.xsOnly">
                <v-card elevation="0" style="border-radius: 10px 0px 0px 10px !important;" class="commission-content-holder full-height primary white--text text-center pa-2 mb-3">
                  <v-card-text style="padding: 5px;">
                    <v-row no-gutters align="end">
                      <v-col cols="12" class="mb-3 white--text d-flex justify-start">
                        <label>{{ $t(`label.todayCommission`) }}</label>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12">
                        <v-card style="background: #060B6D;" color="white--text text-left py-2 pl-6 mb-3">
                          {{ overview.commission_balance | currency(currentCurrency) }}
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row no-gutters align="end">
                      <v-col cols="12" class="mb-3 white--text d-flex justify-start">
                        <label>{{ $t(`label.monthCommission`) }}</label>
                      </v-col>
                    </v-row>
                    <v-row no-gutters align="start">
                      <v-col cols="12">
                        <v-card style="background: #060B6D;" color=" white--text text-left py-2 pl-6">
                          {{ overview.commission_month | currency(currentCurrency) }}
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-divider class="custom-divider-bottom"></v-divider>
                    <v-row justify="center" no-gutters>
                      <v-col cols="12" class="mb-3 d-flex justify-start">
                        <label class="white--text">{{ $t(`label.commissionToRedeem`) }}</label>
                      </v-col>
                      <v-col cols="12" class="mb-0">
                        <v-form ref="redeemForm">
                          <app-form-field
                            :customClass="'commission-redeem-field input-field elevation-0 hide-details'"
                            :enabledLabel="false"
                            v-model.trim="redeemCommissionAmt"
                            :readonly="true"
                            :prefix="currencySymbolMapp(currentCurrency)"
                            :rules="validator.requiredRules()"
                          ></app-form-field>
                        </v-form>
                      </v-col>
                      <v-col cols="12">
                        <app-button customClass="dialog-button text-capitalize" :action="this.redeemCommissionConfirmationDialog" :title="$t(`button.redeem`)"></app-button>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col v-if="!$vuetify.breakpoint.xsOnly" cols="8" class="tier-container-box">
                <v-row style="">
                  <v-col cols="12">
                    <div class="tier-container font-weight-bold">{{ $t(`label.referralTier`) }}</div>
                  </v-col>
                </v-row>
                <v-row no-gutters align="end" style="padding-top: 16px;">
                  <v-col cols="3">
                    <v-card elevation="0" color="border-left-radius primary white--text text-center pa-2 mb-3 mr-1">
                      {{ $t(`label.total`) }}
                    </v-card>
                  </v-col>
                  <v-col cols="3">
                    <v-card elevation="0" color="border-right-radius primary white--text text-center pa-2 mb-3 mr-1">
                      {{ totalPoint }}
                    </v-card>
                  </v-col>
                </v-row>
                <v-row class="d-flex align-center">
                  <!--                  <v-col cols="3" class="d-flex align-center justify-center" style="padding: 0px;">-->
                  <!--                    <v-col cols="11" class="d-flex justify-center" style="padding: 0px;">-->
                  <!--                      <div class="tier-head pa-1 tier-container d-flex justify-end">-->
                  <!--                        <img src="/static/image/referral/referral-people.svg" class="avatar-size" width="auto" height="60" alt="krikya-referral"/>-->
                  <!--                      </div>-->
                  <!--                    </v-col>-->
                  <!--                    <v-col cols="1" style="padding: 0px;">-->
                  <!--                      <img style="transform: rotate(270deg);" class="tier-container" src="/static/image/referral/referral_arrow_down.svg" width="auto"-->
                  <!--                           height="16" alt="krikya-referral"/>-->
                  <!--                    </v-col>-->
                  <!--                  </v-col>-->
                  <v-col cols="3" class="d-flex align-center justify-center" style="padding: 0px;">
                    <v-col cols="2"></v-col>
                    <v-col cols="8" class="d-flex justify-center" style="padding: 0px;">
                      <div class="tier-head pa-1 tier-container d-flex justify-end">
                        <img :src="`/static/image/referral/${language}/referral-tier1.png`" class="avatar-size" width="auto" height="55" alt="krikya-referral" />
                      </div>
                    </v-col>
                    <v-col cols="2" class="customized-icon-position">
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <img class="tier-info" v-bind="attrs" v-on="on" src="/static/image/referral/referral-info.svg" width="auto" height="18" alt="krikya-referral" />
                        </template>
                        <v-row no-gutters class="tier-tool-tip">
                          <v-col cols="12">
                            {{ stringFormat($t(`label.tier`), 1) }}
                          </v-col>
                          <v-col cols="12">
                            {{ stringFormat($t(`label.commissionTips`), getConfig(1)) }}
                          </v-col>
                        </v-row>
                      </v-tooltip>
                    </v-col>
                  </v-col>
                  <v-col cols="1" class="d-flex justify-center align-center" style="padding: 0px;">
                    <img style="transform: rotate(270deg);" class="tier-container" src="/static/image/referral/referral_arrow_down.svg" width="auto" height="16" alt="krikya-referral" />
                  </v-col>
                  <v-col cols="3" class="d-flex align-center justify-center" style="padding: 0px;">
                    <v-col cols="2"></v-col>
                    <v-col cols="8" class="d-flex justify-center" style="padding: 0px;">
                      <div class="tier-head pa-1 tier-container d-flex justify-end">
                        <img :src="`/static/image/referral/${language}/referral-tier2.png`" class="avatar-size" width="auto" height="55" alt="krikya-referral" />
                      </div>
                    </v-col>
                    <v-col cols="2" class="customized-icon-position">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <img class="tier-info" v-bind="attrs" v-on="on" src="/static/image/referral/referral-info.svg" width="auto" height="18" alt="krikya-referral" />
                        </template>
                        <v-row no-gutters class="tier-tool-tip">
                          <v-col cols="12">
                            {{ stringFormat($t(`label.tier`), 2) }}
                          </v-col>
                          <v-col cols="12">
                            {{ stringFormat($t(`label.commissionTips`), getConfig(2)) }}
                          </v-col>
                        </v-row>
                      </v-tooltip>
                    </v-col>
                  </v-col>
                  <v-col cols="1" class="d-flex justify-center align-center" style="padding: 0px;">
                    <img style="transform: rotate(270deg);" class="tier-container" src="/static/image/referral/referral_arrow_down.svg" width="auto" height="16" alt="krikya-referral" />
                  </v-col>
                  <v-col cols="3" class="d-flex align-center justify-center" style="padding: 0px;">
                    <v-col cols="2"></v-col>
                    <v-col cols="8" class="d-flex justify-center" style="padding: 0px;">
                      <div class="tier-head pa-1 tier-container d-flex justify-end">
                        <img :src="`/static/image/referral/${language}/referral-tier3.png`" class="avatar-size" width="auto" height="55" alt="krikya-referral" />
                      </div>
                    </v-col>
                    <v-col cols="2" class="customized-icon-position">
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <img class="tier-info" v-bind="attrs" v-on="on" src="/static/image/referral/referral-info.svg" width="auto" height="18" alt="krikya-referral" />
                        </template>
                        <v-row no-gutters class="tier-tool-tip">
                          <v-col cols="12">
                            {{ stringFormat($t(`label.tier`), 3) }}
                          </v-col>
                          <v-col cols="12">
                            {{ stringFormat($t(`label.commissionTips`), getConfig(3)) }}
                          </v-col>
                        </v-row>
                      </v-tooltip>
                    </v-col>
                  </v-col>
                  <v-col cols="1" style="padding: 0px;">
                    <!--                      <img style="transform: rotate(270deg);" class="tier-container" src="/static/image/referral/referral_arrow_down.svg" width="auto"-->
                    <!--                           height="16" alt="krikya-referral"/>-->
                  </v-col>
                </v-row>
                <v-row style="margin-top: -12px;">
                  <!--                  <v-col cols="3" style="padding: 10px 3px;">-->
                  <!--                    <v-card class="primary text-center tier-container">-->
                  <!--                      <v-card-text class="pa-1">-->
                  <!--                        <v-row no-gutters>-->
                  <!--                          <v-col cols=12 no-gutters>-->
                  <!--                            <label class="white&#45;&#45;text detail">{{ memberInfo.name || memberInfo.memberCode }}</label>-->
                  <!--                          </v-col>-->
                  <!--                        </v-row>-->
                  <!--                      </v-card-text>-->
                  <!--                    </v-card>-->
                  <!--                  </v-col>-->
                  <v-col cols="3">
                    <v-card class="primary text-center tier-container">
                      <v-card-text class="pa-1">
                        <v-row no-gutters>
                          <v-col class="no-gutters" cols="12">
                            <label class="white--text detail">{{ overview.downline_lv1 }}</label>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="1"></v-col>
                  <v-col cols="3">
                    <v-card class="primary text-center tier-container">
                      <v-card-text class="pa-1">
                        <v-row no-gutters>
                          <v-col class="no-gutters" cols="12">
                            <label class="white--text detail">{{ overview.downline_lv2 }}</label>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="1"></v-col>
                  <v-col cols="3">
                    <v-card class="primary text-center tier-container">
                      <v-card-text class="pa-1">
                        <v-row no-gutters>
                          <v-col class="no-gutters" cols="12">
                            <label class="white--text detail">{{ overview.downline_lv3 }}</label>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="1"></v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters style="margin-top: 24px;">
              <v-col v-if="!$vuetify.breakpoint.xsOnly" cols="12" class="border-referralbonus">
                <v-col cols="12" style="display: inline-flex; padding: 12px 24px 0px !important;">
                  <!--          <label class="mx-auto ml-0 mr-1 pa-1" style="width: fit-content">{{ $t(`label.expiredDate`) }} :</label>-->
                  <label class="mx-auto ml-0 pa-1" style="width: fit-content; font-weight: bold">
                    <!--            {{ downlineDetail.expired_at == null || downlineDetail.expired_at == '' ? '-' : downlineDetail.expired_at }}-->
                    {{ $t(`label.referralBonus`) }}
                  </label>
                  <label class="ml-0 pa-1" style="width: fit-content; font-weight: bold">
                    {{ $t(`label.expiredDate`) }} : {{ downlineDetail.is_expired == true ? $t(`label.expired`) : $t(`label.noExpired`) }}
                  </label>
                </v-col>
                <v-col cols="12" style="display: flex;" v-if="!$vuetify.breakpoint.xsOnly">
                  <v-col cols="6">
                    <v-card elevation="0" class="commission-content-card" color="commission-content-holder primary pa-2 mb-3 col-5">
                      <v-card-text>
                        <v-row>
                          <v-col cols="12">
                            <label class="mx-auto ml-0 mr-6 pa-1 white--text" style="width: 100px">{{ $t(`label.freeBonus`) }} ৳</label>
                            <v-card class="font-weight-bold justify-start d-flex" color="title_color2 text-center pa-1 ml-0 mx-auto input-card">
                              {{ decimalTruncate(downlineDetail.bonus_amount, 2) }}
                            </v-card>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <label class="mx-auto ml-0 mr-6 pa-1 white--text" style="width: 100px">{{ $t(`label.deposit`) }}</label>
                            <v-card elevation="0" class="font-weight-bold justify-start d-flex" color="title_color2 text-center pa-1 mx-auto ml-0 input-card">
                              {{ decimalTruncate(downlineDetail.current_deposit, 2) }} /
                              {{ decimalTruncate(downlineDetail.required_deposit, 2) }}
                            </v-card>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <label class="mx-auto ml-0 mr-6 pa-1 white--text" style="width: 100px">{{ $t(`label.turnover`) }}</label>
                            <v-card elevation="0" class="font-weight-bold justify-start d-flex" color="title_color2 text-center pa-1 mx-auto ml-0 input-card">
                              {{ decimalTruncate(downlineDetail.current_valid_bet, 2) }} /
                              {{ decimalTruncate(downlineDetail.required_valid_bet, 2) }}
                            </v-card>
                          </v-col>
                        </v-row>
                        <!--<app-button class="dialog-button mt-6" style="width: 315px" :disabled="downlineDetail.is_claimed != 1" :action="this.claimBonusDialog" :title="$t(`button.claimBonus`)"></app-button>-->
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="6">
                    <v-card elevation="0" class="commission-content-card" color="commission-content-holder base pa-2 mb-3 col-7">
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" class="text-center">
                            <label class="--v-primary-base" style="font-size: 16px">{{ $t(`label.youReferralStatus`) }}</label>
                            <div style="display: flex" class="mt-10 justify-center">
                              <div style="width: fit-content; border-right: 2px dotted rgba(8,8,8);" class="mt-6 pa-3">
                                <div class="text-center">
                                  <label class="referral-text">{{ uplineReferral.accepted_referral }}</label>
                                </div>
                                <div>
                                  <label>{{ $t(`label.friendAccepted`) }}</label>
                                </div>
                              </div>
                              <div style="width: fit-content" class="mt-6 pa-3">
                                <div class="text-center">
                                  <label class="referral-text">{{ uplineReferral.current_referral }}</label>
                                </div>
                                <div>
                                  <label>{{ $t(`label.friendCompleted`) }}</label>
                                </div>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-col>
                <v-col cols="12" style="justify-content: end; display: flex;">
                  <v-row style="justify-content: end; padding: 12px 24px 12px !important;">
                    <v-btn style="width: 200px; border: 1px solid #222CE2;" class="dialog-button subtitle-1 full-width text-capitalize pa-2" @click="redirectDownLineReport()">
                      {{ $t(`button.downLine`) }}
                    </v-btn>
                  </v-row>
                </v-col>
              </v-col>
            </v-row>
          </v-col>

          <v-col v-if="!$vuetify.breakpoint.xsOnly" style="padding-left: 15px;" cols="3">
            <v-row no-gutters class="referralGuideSection" v-if="showReferralGuide">
              <v-col class="pa-0" cols="11">
                <div class="d-flex align-center">
                  <img src="/static/image/profile/guideIcons.png" width="25" height="25" :contain="true" />
                  <label class="px-3">
                    <span class="referralGuideText">{{ $t(`label.referralGuide`) }} {{ $t(`label.clickThis`) }}</span>
                    <a href="https://nagad88.wistia.com/medias/5t8yaspben" target="_blank" class="linkText referralGuideText">{{ $t(`label.link`) }}</a>
                    <span class="referralGuideText">{{ $t(`label.watchVideo`) }}</span>
                  </label>
                </div>
              </v-col>
              <v-col cols="1" class="pa-0 d-flex justify-center align-center">
                <v-img @click="closeShowReferralGuide()" src="/static/image/profile/closeIcon.png" width="15" height="15" :contain="true"></v-img>
              </v-col>
            </v-row>
            <v-row class="video-section">
              <b>{{ $t(`label.howMakeYouRich`) }}</b>
              <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
                <div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">
                  <div class="wistia_embed wistia_async_rq9403kntu seo=true videoFoam=true" style="height:100%;position:relative;width:100%">
                    <div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;">
                      <img
                        src="https://fast.wistia.com/embed/medias/rq9403kntu/swatch"
                        style="filter:blur(5px);height:100%;object-fit:contain;width:100%;"
                        alt=""
                        aria-hidden="true"
                        onload="this.parentNode.style.opacity=1;"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </v-row>
            <v-card elevation="0" class="commission-content-holder base pa-2 mb-3 commissionContentHeight">
              <v-card-text>
                <v-row no-gutters>
                  <v-col cols="10" class="d-flex flex-column justify-center" style="margin:auto">
                    <v-row no-gutters>
                      <v-col class="justify-center text-center flex-column align-center referralText">
                        <span class="blue-text">{{ $t(`label.referralMsg1`) }}</span>
                        {{ $t(`label.referralMsg2`) }}
                      </v-col>
                      <!--                      <v-col class="font-weight-bold text-center">{{ $t(`label.id`) }}:{{ overview.member_id }}</v-col>-->
                      <!--                      <v-col class="font-weight-bold text-right">{{ overview.member_id }}</v-col>-->
                    </v-row>
                    <!--                    <v-row no-gutters>-->
                    <!--                      <v-col class="font-weight-bold text-center">{{ $t(`field.referralCode`) }}:{{ overview.my_referral_code }}</v-col>-->
                    <!--                      &lt;!&ndash;                      <v-col class="font-weight-bold text-right"></v-col>&ndash;&gt;-->
                    <!--                    </v-row>-->
                  </v-col>
                </v-row>
                <v-row class="d-flex justify-center">
                  <v-col cols="12" class="d-flex justify-center">
                    <vue-qr-code v-if="overview.my_referral_code" class="qrCode" :text="share_url" :size="105"></vue-qr-code>
                  </v-col>
                  <v-col cols="12" class="mb-0">
                    <v-row no-gutters justify="center">
                      <v-col cols="11">
                        <!-- <v-img class="mr-2" src="/static/svg/fb_btn.svg" @click="share()"> </v-img> -->
                        <v-btn class="text--style dialog-button subtitle-1 full-width text-capitalize pa-2" @click="share()">
                          <v-icon class="text--style mr-2">mdi-share-variant</v-icon>
                          <span class="text--style">{{ webShareApiSupported ? $t(`button.shareNow`) : $t(`button.copy_ref`) }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="5" v-if="$vuetify.breakpoint.xsOnly">
        <v-row no-gutters class="referralGuideSection mb-0" v-if="showReferralGuide">
          <v-col class="pa-0" cols="11">
            <div class="d-flex align-center">
              <img src="/static/image/profile/guideIcons.png" width="25" height="25" :contain="true" />
              <label class="px-3">
                {{ $t(`label.referralGuide`) }} {{ $t(`label.clickThis`) }}
                <a href="https://nagad88.wistia.com/medias/5t8yaspben" target="_blank" class="linkText">{{ $t(`label.link`) }}</a>
                {{ $t(`label.watchVideo`) }}
              </label>
            </div>
          </v-col>
          <v-col cols="1" class="pa-0 d-flex justify-center align-center">
            <v-img @click="closeShowReferralGuide()" src="/static/image/profile/closeIcon.png" width="15" height="15" :contain="true"></v-img>
          </v-col>
        </v-row>
        <v-row class="video-section mb-0">
          <b>{{ $t(`label.howMakeYouRich`) }}</b>
          <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
            <div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">
              <div class="wistia_embed wistia_async_rq9403kntu seo=true videoFoam=true" style="height:100%;position:relative;width:100%">
                <div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;">
                  <img
                    src="https://fast.wistia.com/embed/medias/rq9403kntu/swatch"
                    style="filter:blur(5px);height:100%;object-fit:contain;width:100%;"
                    alt=""
                    aria-hidden="true"
                    onload="this.parentNode.style.opacity=1;"
                  />
                </div>
              </div>
            </div>
          </div>
        </v-row>
        <v-row>
          <v-col v-if="$vuetify.breakpoint.xsOnly" cols="12" md="7" sm="7">
            <v-card elevation="0" class="commission-content-holder base pa-2 mb-3 full-height">
              <v-card-text>
                <v-row no-gutters>
                  <v-col cols="10" :md="7" class="d-flex flex-column justify-center" style="margin:auto">
                    <v-row no-gutters>
                      <v-col class="justify-center text-center flex-column align-center">
                        <span class="blue-text">{{ $t(`label.referralMsg1`) }}</span>
                        {{ $t(`label.referralMsg2`) }}
                      </v-col>
                      <!--                      <v-col class="d-flex justify-center font-weight-bold text-right">{{ $t(`label.id`) }}: {{ overview.member_id }}</v-col>-->
                    </v-row>
                    <!--                    <v-row no-gutters>-->
                    <!--                      <v-col class="d-flex justify-center font-weight-bold text-right">{{ $t(`field.referralCode`) }}: {{ overview.my_referral_code }}</v-col>-->
                    <!--                    </v-row>-->
                  </v-col>
                </v-row>
                <v-row class="d-flex justify-center">
                  <v-col cols="12" class="d-flex justify-center">
                    <vue-qr-code v-if="overview.my_referral_code" class="" :text="share_url" :size="250"></vue-qr-code>
                  </v-col>
                  <v-col cols="12" md="12" sm="8" class="mb-0">
                    <v-row no-gutters justify="center">
                      <v-col cols="9" lg="6">
                        <!-- <v-img class="mr-2" src="/static/svg/fb_btn.svg" @click="share()"> </v-img> -->
                        <v-btn class="dialog-button subtitle-1 full-width text-capitalize pa-2" @click="share()">
                          <v-icon class="mr-2">mdi-share-variant</v-icon>
                          {{ webShareApiSupported ? $t(`button.shareNow`) : $t(`button.copy_ref`) }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card elevation="0" class="commission-content-holder full-height primary white--text text-center pa-2 mb-3">
              <v-card-text>
                <v-row justify="center" no-gutters>
                  <v-col cols="9" class="mb-3">
                    <label class="white--text">{{ $t(`label.commissionToRedeem`) }}</label>
                  </v-col>
                  <v-col cols="9" class="mb-0">
                    <v-form ref="redeemForm">
                      <app-form-field
                        :customClass="'commission-redeem-field input-field elevation-0 hide-details'"
                        :enabledLabel="false"
                        v-model.trim="redeemCommissionAmt"
                        :readonly="true"
                        :prefix="currencySymbolMapp(currentCurrency)"
                        :rules="validator.requiredRules()"
                      ></app-form-field>
                    </v-form>
                  </v-col>
                  <v-col cols="9">
                    <app-button customClass="dialog-button text-capitalize" :action="redeemCommissionConfirmationDialog" :title="$t(`button.redeem`)"></app-button>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <!--          <v-col cols=12 md=5 sm=6>-->

          <!--          </v-col>-->
        </v-row>
      </v-col>
      <v-col v-if="$vuetify.breakpoint.xsOnly" cols="12" md="5" sm="6">
        <v-row no-gutters align="end">
          <v-col cols="12" style="color: black;">
            <label>{{ $t(`label.todayCommission`) }}</label>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-card color="primary white--text text-left py-2 pl-6 mb-3">
              {{ overview.commission_balance | currency(currentCurrency) }}
            </v-card>
          </v-col>
        </v-row>
        <v-row no-gutters align="end">
          <v-col cols="12" style="color: black;">
            <label>{{ $t(`label.monthCommission`) }}</label>
          </v-col>
        </v-row>
        <v-row no-gutters align="start">
          <v-col cols="12">
            <v-card color="primary white--text text-left py-2 pl-6">
              {{ overview.commission_month | currency(currentCurrency) }}
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col v-if="$vuetify.breakpoint.xsOnly" cols="12" md="6" sm="6">
        <v-row>
          <v-col cols="12">
            <div class="tier-container" style="color: black;">{{ $t(`label.referralTier`) }}</div>
          </v-col>
        </v-row>
        <v-row no-gutters align="end">
          <v-col cols="6">
            <v-card elevation="0" color="border-left-radius primary white--text text-center pa-2 mb-3 mr-1">
              {{ $t(`label.total`) }}
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card elevation="0" color="border-right-radius primary white--text text-center pa-2 mb-3 mr-1">
              {{ totalPoint }}
            </v-card>
          </v-col>
        </v-row>
        <v-row class="referral-tier">
          <!--          <v-col cols=12>-->
          <!--            <div class="tier-head pa-1 tier-container d-flex justify-end">-->
          <!--              <img src="/static/image/referral/referral-people.svg" width="auto" height="75" alt="krikya-referral"/>-->
          <!--            </div>-->
          <!--            <v-card class="primary text-center tier-container">-->
          <!--              <v-card-text class="pa-1">-->
          <!--                <v-row no-gutters>-->
          <!--                  <v-col cols=12 no-gutters>-->
          <!--                    <label class="detail">{{ memberInfo.name || memberInfo.memberCode }}</label>-->
          <!--                  </v-col>-->
          <!--                </v-row>-->
          <!--              </v-card-text>-->
          <!--            </v-card>-->
          <!--          </v-col>-->
          <!--          <v-col cols=12 class="d-flex justify-center">-->
          <!--            <img class="tier-container" src="/static/image/referral/referral_arrow_down.svg" width="auto"-->
          <!--                 height="16" alt="krikya-referral"/>-->
          <!--          </v-col>-->
          <v-col cols="12">
            <div class="tier-head pa-1 tier-container">
              <img :src="`/static/image/referral/${language}/referral-tier1.png`" width="auto" height="55" alt="krikya-referral" />
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <img class="tier-info" v-bind="attrs" v-on="on" src="/static/image/referral/referral-info.svg" width="auto" height="25" alt="krikya-referral" />
                </template>
                <v-row no-gutters class="tier-tool-tip">
                  <v-col cols="12">
                    {{ stringFormat($t(`label.tier`), 1) }}
                  </v-col>
                  <v-col cols="12">
                    {{ stringFormat($t(`label.commissionTips`), getConfig(1)) }}
                  </v-col>
                </v-row>
              </v-tooltip>
            </div>
            <v-card class="primary text-center tier-container">
              <v-card-text class="pa-1">
                <v-row no-gutters>
                  <v-col class="no-gutters" cols="12">
                    <label class="detail">{{ overview.downline_lv1 }}</label>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <img class="tier-container" src="/static/image/referral/referral_arrow_down.svg" width="auto" height="16" alt="krikya-referral" />
          </v-col>
          <v-col cols="12">
            <div class="tier-head pa-1 tier-container">
              <img :src="`/static/image/referral/${language}/referral-tier2.png`" width="auto" height="55" alt="krikya-referral" />
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <img class="tier-info" v-bind="attrs" v-on="on" src="/static/image/referral/referral-info.svg" width="auto" height="25" alt="krikya-referral" />
                </template>
                <v-row no-gutters class="tier-tool-tip">
                  <v-col cols="12">
                    {{ stringFormat($t(`label.tier`), 2) }}
                  </v-col>
                  <v-col cols="12">
                    {{ stringFormat($t(`label.commissionTips`), getConfig(2)) }}
                  </v-col>
                </v-row>
              </v-tooltip>
            </div>
            <v-card class="primary text-center tier-container">
              <v-card-text class="pa-1">
                <v-row no-gutters>
                  <v-col class="no-gutters" cols="12">
                    <label class="detail">{{ overview.downline_lv2 }}</label>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <img class="tier-container" src="/static/image/referral/referral_arrow_down.svg" width="auto" height="16" alt="krikya-referral" />
          </v-col>
          <v-col cols="12">
            <div class="tier-head pa-1 tier-container">
              <img :src="`/static/image/referral/${language}/referral-tier3.png`" width="auto" height="55" alt="krikya-referral" />
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <img class="tier-info" v-bind="attrs" v-on="on" src="/static/image/referral/referral-info.svg" width="auto" height="25" alt="krikya-referral" />
                </template>
                <v-row no-gutters class="tier-tool-tip">
                  <v-col cols="12">
                    {{ stringFormat($t(`label.tier`), 3) }}
                  </v-col>
                  <v-col cols="12">
                    {{ stringFormat($t(`label.commissionTips`), getConfig(3)) }}
                  </v-col>
                </v-row>
              </v-tooltip>
            </div>
            <v-card class="primary text-center tier-container">
              <v-card-text class="pa-1">
                <v-row no-gutters>
                  <v-col class="no-gutters" cols="12">
                    <label class="detail">{{ overview.downline_lv3 }}</label>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <!--      <div style="display: flex">-->
      <!--        -->
      <!--      </div>-->
      <v-row></v-row>
      <!--      <v-row no-gutters style="padding: 12px;">-->
      <!--        <v-col v-if="!$vuetify.breakpoint.xsOnly" cols="9" class="border-referralbonus">-->
      <!--          <v-col cols="12" style="display: inline-flex; padding: 12px 24px 0px !important;">-->
      <!--            &lt;!&ndash;          <label class="mx-auto ml-0 mr-1 pa-1" style="width: fit-content">{{ $t(`label.expiredDate`) }} :</label>&ndash;&gt;-->
      <!--            <label class="mx-auto ml-0 pa-1" style="width: fit-content; font-weight: bold">-->
      <!--              &lt;!&ndash;            {{ downlineDetail.expired_at == null || downlineDetail.expired_at == '' ? '-' : downlineDetail.expired_at }}&ndash;&gt;-->
      <!--              {{ $t(`label.referralBonus`) }}-->
      <!--            </label>-->
      <!--            <label class="ml-0 pa-1" style="width: fit-content; font-weight: bold">-->
      <!--              {{ $t(`label.expiredDate`) }} : {{ downlineDetail.is_expired == true ? 'Expired' : 'No Expired' }}</label>-->
      <!--          </v-col>-->
      <!--          <v-col cols="12" style="display: flex;" v-if="!$vuetify.breakpoint.xsOnly">-->
      <!--            <v-col cols="6"><v-card elevation="0" class="commission-content-card"  color="commission-content-holder primary pa-2 mb-3 col-5">-->
      <!--              <v-card-text class="ma-3">-->

      <!--                <v-row>-->
      <!--                  <v-col cols="12" style="display: inline-flex">-->
      <!--                    <label class="mx-auto ml-0 mr-6 pa-1" style="width: 100px">{{ $t(`label.freeBonus`) }} ৳</label>-->
      <!--                    <v-card class="font-weight-bold"-->
      <!--                            color="border-left-radius title_color2 text-center pa-1 ml-0 mx-auto input-card"-->
      <!--                            style="width: 215px">-->
      <!--                      {{ decimalTruncate(downlineDetail.bonus_amount, 2) }}-->
      <!--                    </v-card>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--                <v-row>-->
      <!--                  <v-col cols="12" style="display: inline-flex">-->
      <!--                    <label class="mx-auto ml-0 mr-6 pa-1" style="width: 100px">{{ $t(`label.deposit`) }}</label>-->
      <!--                    <v-card elevation="0"-->
      <!--                            color="border-left-radius title_color2 text-center pa-1 mx-auto ml-0 input-card"-->
      <!--                            style="width: 215px">-->
      <!--                      {{ decimalTruncate(downlineDetail.current_deposit, 2) }} /-->
      <!--                      {{ decimalTruncate(downlineDetail.required_deposit, 2) }}-->
      <!--                    </v-card>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--                <v-row>-->
      <!--                  <v-col cols="12" style="display: inline-flex">-->
      <!--                    <label class="mx-auto ml-0 mr-6 pa-1" style="width: 100px">{{ $t(`label.turnover`) }}</label>-->
      <!--                    <v-card elevation="0"-->
      <!--                            color="border-left-radius title_color2 text-center pa-1 mx-auto ml-0 input-card"-->
      <!--                            style="width: 215px;color: ">-->
      <!--                      {{ decimalTruncate(downlineDetail.current_valid_bet, 2) }} /-->
      <!--                      {{ decimalTruncate(downlineDetail.required_valid_bet, 2) }}-->
      <!--                    </v-card>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--                &lt;!&ndash;<app-button class="dialog-button mt-6" style="width: 315px" :disabled="downlineDetail.is_claimed != 1" :action="this.claimBonusDialog" :title="$t(`button.claimBonus`)"></app-button>&ndash;&gt;-->
      <!--              </v-card-text>-->
      <!--            </v-card></v-col>-->
      <!--            <v-col cols="6"><v-card elevation="0" class="commission-content-card" color="commission-content-holder base pa-2 mb-3 col-7">-->
      <!--              <v-card-text>-->
      <!--                <v-row>-->
      <!--                  <v-col cols="12" class="text-center">-->
      <!--                    <label class="&#45;&#45;v-primary-base" style="font-size: 16px">{{-->
      <!--                        $t(`label.youReferralStatus`)-->
      <!--                      }}</label>-->
      <!--                    <div style="display: flex" class="mt-10 justify-center">-->
      <!--                      <div style="width: fit-content; border-right: 2px dotted rgba(8,8,8);" class="mt-6 pa-3">-->
      <!--                        <div class="text-center">-->
      <!--                          <label class="referral-text">{{ uplineReferral.accepted_referral }}</label>-->
      <!--                        </div>-->
      <!--                        <div>-->
      <!--                          <label>Friend's Accepted</label>-->
      <!--                        </div>-->
      <!--                      </div>-->
      <!--                      <div style="width: fit-content" class="mt-6 pa-3">-->
      <!--                        <div class="text-center">-->
      <!--                          <label class="referral-text">{{ uplineReferral.current_referral }}</label>-->
      <!--                        </div>-->
      <!--                        <div>-->
      <!--                          <label>Friend's Complete</label>-->
      <!--                        </div>-->
      <!--                      </div>-->
      <!--                    </div>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--              </v-card-text>-->
      <!--            </v-card></v-col>-->
      <!--          </v-col>-->
      <!--          <v-col cols="12" style="justify-content: end; display: flex;">-->
      <!--            <v-row style="justify-content: end; padding: 12px 24px 12px !important;">-->
      <!--              <v-btn style="width: 200px;" class="dialog-button subtitle-1 full-width text-capitalize pa-2" @click="redirectDownLineReport()">-->
      <!--                {{ $t(`button.downLine`) }}-->
      <!--              </v-btn>-->
      <!--            </v-row>-->
      <!--          </v-col>-->
      <!--        </v-col>-->

      <!--      </v-row>-->
      <!--      <v-col cols=12 md=7 sm=7>-->
      <!--        <v-card elevation="0" class="commission-content-holder base pa-2 mb-3 full-height">-->
      <!--          <v-card-text>-->
      <!--            <v-row no-gutters>-->
      <!--              <v-col cols=10 :md="7" class="d-flex flex-column justify-center" style="margin:auto">-->
      <!--                <v-row no-gutters>-->
      <!--                  <v-col>{{ $t(`label.id`) }}:</v-col>-->
      <!--                  <v-col class="font-weight-bold text-right">{{ overview.member_id }}</v-col>-->
      <!--                </v-row>-->
      <!--                <v-row no-gutters>-->
      <!--                  <v-col>{{ $t(`field.referralCode`) }}:</v-col>-->
      <!--                  <v-col class="font-weight-bold text-right">{{ overview.my_referral_code }}</v-col>-->
      <!--                </v-row>-->
      <!--              </v-col>-->
      <!--            </v-row>-->
      <!--            <v-row class="d-flex justify-center">-->
      <!--              <v-col cols="12" class="d-flex justify-center">-->
      <!--                <vue-qr-code v-if="overview.my_referral_code" class="qrCode" :text="share_url"-->
      <!--                             :size="105"></vue-qr-code>-->
      <!--              </v-col>-->
      <!--              <v-col cols=12 md=12 sm=8 class="mb-0">-->
      <!--                <v-row no-gutters justify="center">-->
      <!--                  <v-col cols=8 lg=6>-->
      <!--                    &lt;!&ndash; <v-img class="mr-2" src="/static/svg/fb_btn.svg" @click="share()"> </v-img> &ndash;&gt;-->
      <!--                    <v-btn class="dialog-button subtitle-1 full-width text-capitalize pa-2" @click="share()">-->
      <!--                      <v-icon class="mr-2">mdi-share-variant</v-icon>-->
      <!--                      {{ webShareApiSupported ? $t(`button.shareNow`)  : $t(`button.copy_ref`) }}-->
      <!--                    </v-btn>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--              </v-col>-->
      <!--            </v-row>-->
      <!--          </v-card-text>-->
      <!--        </v-card>-->
      <!--      </v-col>-->
    </v-row>
    <!--    <v-row>-->
    <!--      <v-col cols="12" md="5">-->
    <!--        <v-row>-->
    <!--          <v-col cols="12" v-if="$vuetify.breakpoint.xsOnly">-->
    <!--            <v-card elevation="0" class="commission-content-holder full-height primary white&#45;&#45;text text-center pa-2 mb-3">-->
    <!--              <v-card-text>-->
    <!--                <v-row justify="center" no-gutters>-->
    <!--                  <v-col cols="9" class="mb-3">-->
    <!--                    <label class="white&#45;&#45;text">{{ $t(`label.commissionToRedeem`) }}</label>-->
    <!--                  </v-col>-->
    <!--                  <v-col cols="9" class="mb-0">-->
    <!--                    <v-form ref="redeemForm">-->
    <!--                      <app-form-field-->
    <!--                        :customClass="'commission-redeem-field input-field elevation-0 hide-details'"-->
    <!--                        :enabledLabel="false"-->
    <!--                        v-model.trim="redeemCommissionAmt"-->
    <!--                        :readonly="true"-->
    <!--                        :prefix="currencySymbolMapp(currentCurrency)"-->
    <!--                        :rules="validator.requiredRules()"-->
    <!--                        class="amount-textarea"-->
    <!--                      ></app-form-field>-->
    <!--                    </v-form>-->

    <!--                  </v-col>-->
    <!--                  <v-col cols="9">-->
    <!--                    <v-text-field-->
    <!--                      :prefix="'+'"-->
    <!--                      :value="formattedValue"-->
    <!--                      filled disabled-->
    <!--                      readonly-->
    <!--                      class="redeem-textarea">-->
    <!--                      <template v-slot:append>-->
    <!--                        <v-tooltip right>-->
    <!--                          <template v-slot:activator="{ on }">-->
    <!--                            <img-->
    <!--                              class="tier-info"-->
    <!--                              v-on="on"-->
    <!--                              src="/static/image/referral/referral-info.svg"-->
    <!--                              width="auto"-->
    <!--                              height="25"-->
    <!--                            />-->
    <!--                          </template>-->
    <!--                          <v-col cols="12">-->
    <!--                            {{ stringFormat($t(`label.bonus10000`)) }}-->
    <!--                          </v-col>-->
    <!--                          <v-col cols="12">-->
    <!--                            {{ stringFormat($t(`label.frequency`)) }}-->
    <!--                          </v-col>-->
    <!--                          <v-col cols="12">-->
    <!--                            {{ stringFormat($t(`label.criteria1`)) }}-->
    <!--                          </v-col>-->
    <!--                          <v-col cols="12">-->
    <!--                            {{ stringFormat($t(`label.criteria2`)) }}-->
    <!--                          </v-col>-->
    <!--                        </v-tooltip>-->
    <!--                      </template>-->
    <!--                    </v-text-field>-->
    <!--                  </v-col>-->
    <!--                  <v-col cols="9">-->
    <!--                    <app-button customClass="dialog-button text-capitalize" :action="redeemCommissionConfirmationDialog" :title="$t(`button.redeem`)"></app-button>-->
    <!--                  </v-col>-->
    <!--                </v-row>-->
    <!--              </v-card-text>-->
    <!--            </v-card>-->
    <!--          </v-col>-->
    <!--          <v-col cols="12" md="5" sm="6">-->
    <!--            <v-row no-gutters align="end">-->
    <!--              <v-col cols="12">-->
    <!--                <label>{{ $t(`label.todayCommission`) }}</label>-->
    <!--              </v-col>-->
    <!--            </v-row>-->
    <!--            <v-row no-gutters>-->
    <!--              <v-col cols="12">-->
    <!--                <v-card color="primary white&#45;&#45;text text-left py-2 pl-6 mb-3">-->
    <!--                  {{ overview.commission_balance | currency(currentCurrency) }}-->
    <!--                </v-card>-->
    <!--              </v-col>-->
    <!--            </v-row>-->
    <!--            <v-row no-gutters align="end">-->
    <!--              <v-col cols="12">-->
    <!--                <label>{{ $t(`label.monthCommission`) }}</label>-->
    <!--              </v-col>-->
    <!--            </v-row>-->
    <!--            <v-row no-gutters align="start">-->
    <!--              <v-col cols="12">-->
    <!--                <v-card color="primary white&#45;&#45;text text-left py-2 pl-6">-->
    <!--                  {{ overview.commission_month | currency(currentCurrency) }}-->
    <!--                </v-card>-->
    <!--              </v-col>-->
    <!--            </v-row>-->
    <!--          </v-col>-->
    <!--          <v-col cols="12" md="6" sm="6">-->
    <!--            <v-row>-->
    <!--              <v-col cols="12">-->
    <!--                <div class="tier-container">{{ $t(`label.referralTier`) }}</div>-->
    <!--              </v-col>-->
    <!--            </v-row>-->
    <!--            <v-row no-gutters align="end">-->
    <!--              <v-col cols="6">-->
    <!--                <v-card elevation="0" color="border-left-radius primary white&#45;&#45;text text-center pa-2 mb-3 mr-1">-->
    <!--                  {{ $t(`label.total`) }}-->
    <!--                </v-card>-->
    <!--              </v-col>-->
    <!--              <v-col cols="6">-->
    <!--                <v-card elevation="0" color="border-right-radius primary white&#45;&#45;text text-center pa-2 mb-3 mr-1">-->
    <!--                  {{ totalPoint }}-->
    <!--                </v-card>-->
    <!--              </v-col>-->
    <!--            </v-row>-->
    <!--            <v-row class="referral-tier">-->
    <!--              &lt;!&ndash;              <v-col cols=12>&ndash;&gt;-->
    <!--              &lt;!&ndash;                <div class="tier-head pa-1 tier-container d-flex justify-end">&ndash;&gt;-->
    <!--              &lt;!&ndash;                  <img src="/static/image/referral/referral-people.svg" width="auto" height="75" alt="krikya-referral"/>&ndash;&gt;-->
    <!--              &lt;!&ndash;                </div>&ndash;&gt;-->
    <!--              &lt;!&ndash;                <v-card class="primary text-center tier-container">&ndash;&gt;-->
    <!--              &lt;!&ndash;                  <v-card-text class="pa-1">&ndash;&gt;-->
    <!--              &lt;!&ndash;                    <v-row no-gutters>&ndash;&gt;-->
    <!--              &lt;!&ndash;                      <v-col cols=12 no-gutters>&ndash;&gt;-->
    <!--              &lt;!&ndash;                        <label class="detail">{{ memberInfo.name || memberInfo.memberCode }}</label>&ndash;&gt;-->
    <!--              &lt;!&ndash;                      </v-col>&ndash;&gt;-->
    <!--              &lt;!&ndash;                    </v-row>&ndash;&gt;-->
    <!--              &lt;!&ndash;                  </v-card-text>&ndash;&gt;-->
    <!--              &lt;!&ndash;                </v-card>&ndash;&gt;-->
    <!--              &lt;!&ndash;              </v-col>&ndash;&gt;-->
    <!--              &lt;!&ndash;              <v-col cols=12 class="d-flex justify-center">&ndash;&gt;-->
    <!--              &lt;!&ndash;                <img class="tier-container" src="/static/image/referral/referral_arrow_down.svg" width="auto"&ndash;&gt;-->
    <!--              &lt;!&ndash;                     height="16" alt="krikya-referral"/>&ndash;&gt;-->
    <!--              &lt;!&ndash;              </v-col>&ndash;&gt;-->
    <!--              <v-col cols="12">-->
    <!--                <div class="tier-head pa-1 tier-container d-flex justify-end">-->
    <!--                  <img src="/static/image/referral/referral-tier1.png" width="170" height="149" alt="nagad88-referral" />-->
    <!--                  <v-tooltip right>-->
    <!--                    <template v-slot:activator="{ on, attrs }">-->
    <!--                      <img class="tier-info" v-bind="attrs" v-on="on" src="/static/image/referral/referral-info.svg" width="auto" height="25" alt="nagad88-referral" />-->
    <!--                    </template>-->
    <!--                    <v-row no-gutters class="tier-tool-tip">-->
    <!--                      <v-col cols="12">-->
    <!--                        {{ stringFormat($t(`label.tier`), 1) }}-->
    <!--                      </v-col>-->
    <!--                      <v-col cols="12">-->
    <!--                        {{ stringFormat($t(`label.commissionTips`), getConfig(1)) }}-->
    <!--                      </v-col>-->
    <!--                    </v-row>-->
    <!--                  </v-tooltip>-->
    <!--                </div>-->
    <!--                <v-card class="primary text-center tier-container">-->
    <!--                  <v-card-text class="pa-1">-->
    <!--                    <v-row no-gutters>-->
    <!--                      <v-col class="no-gutters" cols="12">-->
    <!--                        <label class="detail">{{ $t(`label.totalamount`) }}</label>-->
    <!--                        <label class="detail">{{ overview.downline_lv1 }}</label>-->
    <!--                      </v-col>-->
    <!--                    </v-row>-->
    <!--                  </v-card-text>-->
    <!--                </v-card>-->
    <!--              </v-col>-->
    <!--              <v-col cols="12" class="d-flex justify-center">-->
    <!--                <img class="tier-container" src="/static/image/referral/referral_arrow_down.svg" width="auto" height="16" alt="nagad88-referral" />-->
    <!--              </v-col>-->
    <!--              <v-col cols="12">-->
    <!--                <div class="tier-head pa-1 tier-container d-flex justify-end">-->
    <!--                  <img src="/static/image/referral/referral-tier2.png" width="auto" height="149" alt="nagad88-referral" />-->
    <!--                  <v-tooltip right>-->
    <!--                    <template v-slot:activator="{ on, attrs }">-->
    <!--                      <img class="tier-info" v-bind="attrs" v-on="on" src="/static/image/referral/referral-info.svg" width="auto" height="25" alt="nagad88-referral" />-->
    <!--                    </template>-->
    <!--                    <v-row no-gutters class="tier-tool-tip">-->
    <!--                      <v-col cols="12">-->
    <!--                        {{ stringFormat($t(`label.tier`), 2) }}-->
    <!--                      </v-col>-->
    <!--                      <v-col cols="12">-->
    <!--                        {{ stringFormat($t(`label.commissionTips`), getConfig(2)) }}-->
    <!--                      </v-col>-->
    <!--                    </v-row>-->
    <!--                  </v-tooltip>-->
    <!--                </div>-->
    <!--                <v-card class="primary text-center tier-container">-->
    <!--                  <v-card-text class="pa-1">-->
    <!--                    <v-row no-gutters>-->
    <!--                      <v-col class="no-gutters" cols="12">-->
    <!--                        <label class="detail">{{ $t(`label.totalamount`) }}</label>-->
    <!--                        <label class="detail">{{ overview.downline_lv2 }}</label>-->
    <!--                      </v-col>-->
    <!--                    </v-row>-->
    <!--                  </v-card-text>-->
    <!--                </v-card>-->
    <!--              </v-col>-->
    <!--              <v-col cols="12" class="d-flex justify-center">-->
    <!--                <img class="tier-container" src="/static/image/referral/referral_arrow_down.svg" width="auto" height="16" alt="nagad88-referral" />-->
    <!--              </v-col>-->
    <!--              <v-col cols="12">-->
    <!--                <div class="tier-head pa-1 tier-container d-flex justify-end">-->
    <!--                  <img src="/static/image/referral/referral-tier3.png" width="auto" height="149" alt="nagad88-referral" />-->
    <!--                  <v-tooltip right>-->
    <!--                    <template v-slot:activator="{ on, attrs }">-->
    <!--                      <img class="tier-info" v-bind="attrs" v-on="on" src="/static/image/referral/referral-info.svg" width="auto" height="25" alt="nagad88-referral" />-->
    <!--                    </template>-->
    <!--                    <v-row no-gutters class="tier-tool-tip">-->
    <!--                      <v-col cols="12">-->
    <!--                        {{ stringFormat($t(`label.tier`), 3) }}-->
    <!--                      </v-col>-->
    <!--                      <v-col cols="12">-->
    <!--                        {{ stringFormat($t(`label.commissionTips`), getConfig(3)) }}-->
    <!--                      </v-col>-->
    <!--                    </v-row>-->
    <!--                  </v-tooltip>-->
    <!--                </div>-->
    <!--                <v-card class="primary text-center tier-container">-->
    <!--                  <v-card-text class="pa-1">-->
    <!--                    <v-row no-gutters>-->
    <!--                      <v-col class="no-gutters" cols="12">-->
    <!--                        <label class="detail">{{ $t(`label.totalamount`) }}</label>-->
    <!--                        <label class="detail">{{ overview.downline_lv3 }}</label>-->
    <!--                      </v-col>-->
    <!--                    </v-row>-->
    <!--                  </v-card-text>-->
    <!--                </v-card>-->
    <!--              </v-col>-->
    <!--            </v-row>-->
    <!--          </v-col>-->
    <!--        </v-row>-->
    <!--      </v-col>-->
    <!--      <v-col cols="12" md="7">-->
    <!--        <v-row no-gutters>-->
    <!--          <v-col cols="5" v-if="!$vuetify.breakpoint.xsOnly">-->
    <!--            <v-card elevation="0" class="commission-content-holder full-height primary white&#45;&#45;text text-center pa-2 mb-3">-->
    <!--              <v-card-text>-->
    <!--                <v-row justify="center" no-gutters>-->
    <!--                  <v-col cols="9" class="mb-3">-->
    <!--                    <label class="white&#45;&#45;text">{{ $t(`label.commissionToRedeem`) }}</label>-->
    <!--                  </v-col>-->
    <!--                  <v-col cols="9" class="mb-0">-->
    <!--                    <v-form ref="redeemForm">-->
    <!--                      <app-form-field-->
    <!--                        :customClass="'commission-redeem-field input-field elevation-0 hide-details'"-->
    <!--                        :enabledLabel="false"-->
    <!--                        v-model.trim="redeemCommissionAmt"-->
    <!--                        :readonly="true"-->
    <!--                        :prefix="currencySymbolMapp(currentCurrency)"-->
    <!--                        :rules="validator.requiredRules()"-->
    <!--                      ></app-form-field>-->
    <!--                    </v-form>-->
    <!--                  </v-col>-->
    <!--                  <v-col cols="9">-->
    <!--                    <v-text-field-->
    <!--                      :prefix="'+'"-->
    <!--                      :value="formattedValue"-->
    <!--                      filled disabled-->
    <!--                      readonly-->
    <!--                      class="redeem-textarea">-->
    <!--                      <template v-slot:append>-->
    <!--                        <v-tooltip right>-->
    <!--                          <template v-slot:activator="{ on }">-->
    <!--                            <img-->
    <!--                              class="tier-info"-->
    <!--                              v-on="on"-->
    <!--                              src="/static/image/referral/referral-info.svg"-->
    <!--                              width="auto"-->
    <!--                              height="25"-->
    <!--                            />-->
    <!--                          </template>-->
    <!--                          <v-col cols="12">-->
    <!--                            {{ stringFormat($t(`label.bonus10000`)) }}-->
    <!--                          </v-col>-->
    <!--                          <v-col cols="12">-->
    <!--                            {{ stringFormat($t(`label.frequency`)) }}-->
    <!--                          </v-col>-->
    <!--                          <v-col cols="12">-->
    <!--                            {{ stringFormat($t(`label.criteria1`)) }}-->
    <!--                          </v-col>-->
    <!--                          <v-col cols="12">-->
    <!--                            {{ stringFormat($t(`label.criteria2`)) }}-->
    <!--                          </v-col>-->
    <!--                          &lt;!&ndash;                          <v-col cols="12">&ndash;&gt;-->
    <!--                          &lt;!&ndash;                            {{ stringFormat($t(`label.commissionTips`), getConfig(1)) }}&ndash;&gt;-->
    <!--                          &lt;!&ndash;                          </v-col>&ndash;&gt;-->
    <!--                        </v-tooltip>-->
    <!--                      </template>-->
    <!--                    </v-text-field>-->
    <!--                  </v-col>-->
    <!--                  <v-col cols="9">-->
    <!--                    <app-button customClass="dialog-button text-capitalize" :action="this.redeemCommissionConfirmationDialog" :title="$t(`button.redeem`)"></app-button>-->
    <!--                  </v-col>-->
    <!--                </v-row>-->
    <!--              </v-card-text>-->
    <!--            </v-card>-->
    <!--          </v-col>-->
    <!--          <v-col cols="12" md="7" sm="7">-->
    <!--            <v-card elevation="0" class="commission-content-holder base pa-2 mb-3 full-height">-->
    <!--              <v-card-text>-->
    <!--                <v-row no-gutters>-->
    <!--                  <v-col cols="12" :md="7" class="d-flex flex-column justify-center" style="margin:auto">-->
    <!--                    <v-row no-gutters>-->
    <!--                      <v-col>-->
    <!--                        <span class="blue-text">Share your amazing experience with us to your friends Now!</span>-->
    <!--                        Both of you will get the bonus when your friend sign up using the code stated below.-->
    <!--                      </v-col>-->
    <!--                      &lt;!&ndash;                      <v-col>{{ $t(`label.id`) }}:</v-col>&ndash;&gt;-->
    <!--                      &lt;!&ndash;                      <v-col class="font-weight-bold text-right">{{ overview.member_id }}</v-col>&ndash;&gt;-->
    <!--                    </v-row>-->
    <!--                    &lt;!&ndash;                    <v-row no-gutters>&ndash;&gt;-->
    <!--                    &lt;!&ndash;                      <v-col>{{ $t(`field.referralCode`) }}:</v-col>&ndash;&gt;-->
    <!--                    &lt;!&ndash;                      <v-col class="font-weight-bold text-right">{{ overview.my_referral_code }}</v-col>&ndash;&gt;-->
    <!--                    &lt;!&ndash;                    </v-row>&ndash;&gt;-->
    <!--                  </v-col>-->
    <!--                </v-row>-->
    <!--                <v-row class="d-flex justify-center">-->
    <!--                  <v-col cols="12" class="d-flex justify-center">-->
    <!--                    <vue-qr-code v-if="overview.my_referral_code" class="qrCode" :text="share_url" :size="105"></vue-qr-code>-->
    <!--                  </v-col>-->
    <!--                  &lt;!&ndash;                  <v-col cols="9" class="d-flex">&ndash;&gt;-->
    <!--                  &lt;!&ndash;                    &lt;!&ndash;                    label="Referral Code"&ndash;&gt;&ndash;&gt;-->
    <!--                  &lt;!&ndash;                    <v-text-field v-model="overview.my_referral_code" :label="''" outlined="false" disabled>&ndash;&gt;-->
    <!--                  &lt;!&ndash;                      <img height="20" width="auto" src="/static/image/referral/copyBtn.png" @click="copyToClipboard(overview.my_referral_code)" />&ndash;&gt;-->
    <!--                  &lt;!&ndash;                    </v-text-field>&ndash;&gt;-->
    <!--                  &lt;!&ndash;                    &lt;!&ndash;                      <v-btn class="ml-2" @click="copyToClipboard(overview.my_referral_code)">Copy</v-btn>&ndash;&gt;&ndash;&gt;-->
    <!--                  &lt;!&ndash;                  </v-col>&ndash;&gt;-->
    <!--                  <v-row style="align-items: center; justify-content: center;">-->
    <!--                    <v-col cols="6">-->
    <!--                      <v-text-field-->
    <!--                        outlined-->
    <!--                        v-model="overview.my_referral_code"-->
    <!--                        :label="''"-->
    <!--                        readonly-->
    <!--                        class="show-copyreferral"-->
    <!--                      >-->
    <!--                        <template v-slot:append>-->
    <!--                          <v-tooltip right>-->
    <!--                            <template v-slot:activator="{ on }">-->
    <!--                              <img-->
    <!--                                class="tier-info"-->
    <!--                                v-on="on"-->
    <!--                                src="/static/image/referral/copyBtn.png"-->
    <!--                                width="auto"-->
    <!--                                height="25"-->
    <!--                                @click="copyToClipboard(overview.my_referral_code)"-->
    <!--                              />-->
    <!--                            </template>-->
    <!--                            <v-col cols="12">-->
    <!--                              {{ $t(`label.copyText`) }}-->
    <!--                            </v-col>-->
    <!--                          </v-tooltip>-->
    <!--                        </template>-->
    <!--                        &lt;!&ndash;                        <template v-slot:append>&ndash;&gt;-->
    <!--                        &lt;!&ndash;                          <img height="20" width="auto"   />&ndash;&gt;-->
    <!--                        &lt;!&ndash;&lt;!&ndash;                          <span v-if="isCopied" class="success-message">Copied successfully</span>&ndash;&gt;&ndash;&gt;-->
    <!--                        &lt;!&ndash;                        </template>&ndash;&gt;-->
    <!--                      </v-text-field>-->
    <!--                      &lt;!&ndash;                      <v-text-field v-model="overview.my_referral_code" :label="''" outlined="false" disabled>&ndash;&gt;-->
    <!--                      &lt;!&ndash;                      </v-text-field>&ndash;&gt;-->
    <!--                      &lt;!&ndash;                    </v-col>&ndash;&gt;-->
    <!--                      &lt;!&ndash;                    <v-col cols="1">&ndash;&gt;-->
    <!--                      &lt;!&ndash;                      <img height="20" width="auto" src="/static/image/referral/copyBtn.png" @click="copyToClipboard(overview.my_referral_code)" />&ndash;&gt;-->
    <!--                    </v-col>-->
    <!--                  </v-row>-->
    <!--                  <v-col cols="12" md="12" sm="8" class="mb-0">-->
    <!--                    <v-row no-gutters justify="center">-->
    <!--                      <v-col cols="8" lg="6">-->
    <!--                        &lt;!&ndash; <v-img class="mr-2" src="/static/svg/fb_btn.svg" @click="share()">-->
    <!--                                                   <v-icon class="mr-2">mdi-share-variant</v-icon>-->
    <!--                         </v-img> &ndash;&gt;-->
    <!--                        <v-btn class="dialog-button subtitle-1 full-width text-capitalize pa-2" @click="share()">-->

    <!--                          {{ webShareApiSupported ? $t(`button.shareNow`) : $t(`button.copy_ref`) }}-->
    <!--                        </v-btn>-->
    <!--                      </v-col>-->
    <!--                    </v-row>-->
    <!--                  </v-col>-->
    <!--                </v-row>-->
    <!--              </v-card-text>-->
    <!--            </v-card>-->
    <!--          </v-col>-->
    <!--        </v-row>-->
    <!--      </v-col>-->
    <!--    </v-row>-->
    <v-snackbar class="pa-0" style="z-index:1000 !important;top:7%" light timeout="1000" v-model="alertShow" width="fit-content" top centered>
      <v-alert
        v-model="alertShow"
        dismissible
        :icon="alertSuccess ? 'mdi-check-circle-outline' : 'mdi-cancel'"
        class="mb-0 pa-1"
        :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
        light
        close-icon="mdi-close"
      >
        {{ alertMessage }}
      </v-alert>
    </v-snackbar>
    <!--    <div class="vip-tier">-->
    <!--      <h1 style="color: darkorange; text-align: center;    font-size: 18px; padding-bottom: 20px;">Benefits As Our VIP</h1>-->
    <!--      <p class="lefttext">Current Status</p>-->
    <!--      <v-row no-gutters class="MB-row pa-3">-->
    <!--        <v-col class="MB-left-col pr-4">-->
    <!--          <v-row no-gutters>-->
    <!--            <v-col cols="12"><span class="membercode-span highlighted-span">{{ memberInfo.memberCode }}</span></v-col>-->
    <!--          </v-row no-gutters>-->
    <!--          <v-row class="left-col-btm-row" no-gutters>-->

    <!--            <v-col cols="12" class="text-left white&#45;&#45;text"><span style="font-size: 12px;">{{ $t(`label.balance`) }}</span>-->
    <!--              <v-icon small color="black" class="rotating" style="margin-left:5px;" @click="getMemberWallet()">-->
    <!--                mdi-reload-->
    <!--              </v-icon>-->
    <!--            </v-col>-->
    <!--            <v-col cols="12">-->
    <!--            <span v-if="notLoading" class="highlighted-span">{{-->
    <!--                memberWallet.totalBalance | currency(currentCurrency)-->
    <!--              }}</span>-->
    <!--              <v-progress-circular indeterminate v-if="!notLoading" color="amber" :width="3"-->
    <!--                                   :size="24"></v-progress-circular>-->
    <!--            </v-col>-->

    <!--          </v-row>-->

    <!--          <v-row no-gutters v-if="showProgress">-->
    <!--            <v-col cols="12">-->
    <!--              <v-progress-linear :value="currentProgressPercentage" size="20" :background-color="`viptier${tierColorThemeName}`" color="white"></v-progress-linear>-->
    <!--            </v-col>-->
    <!--            <v-col class="progress-details-col">-->
    <!--              <span>{{$t(`label.lv`)}} {{currentLv}}</span>-->
    <!--              <span>{{ progressRequired }} {{$t(`label.moreToNextLvl`)}}</span>-->
    <!--              <span>{{$t(`label.lv`) }} {{nextLv}}</span>-->
    <!--            </v-col>-->
    <!--          </v-row>-->
    <!--        </v-col>-->
    <!--        &lt;!&ndash;   first draft design   &ndash;&gt;-->
    <!--        &lt;!&ndash;      <v-col cols="6" class="nav-container">&ndash;&gt;-->
    <!--        &lt;!&ndash;        <div class="mx-auto nav-wrapper">&ndash;&gt;-->
    <!--        &lt;!&ndash;          <v-card class="nav-item" :to="{ name: routeName.VIP }">&ndash;&gt;-->
    <!--        &lt;!&ndash;            <img class="img-nav-item" :src="`/static/svg/mobileMemberBalance/bettingPass.svg`" />&ndash;&gt;-->
    <!--        &lt;!&ndash;          </v-card>&ndash;&gt;-->
    <!--        &lt;!&ndash;          <span class="nav-item-span">{{ $t(`mobileMenuTitle.bettingPass`) }}</span>&ndash;&gt;-->
    <!--        &lt;!&ndash;        </div>&ndash;&gt;-->
    <!--        &lt;!&ndash;        <div class="mx-auto nav-wrapper">&ndash;&gt;-->
    <!--        &lt;!&ndash;          <v-card class="nav-item" :to="{ name: routeName.REWARDS }">&ndash;&gt;-->
    <!--        &lt;!&ndash;            <img class="img-nav-item" :src="`/static/svg/mobileMemberBalance/rewards.svg`" />&ndash;&gt;-->
    <!--        &lt;!&ndash;          </v-card>&ndash;&gt;-->
    <!--        &lt;!&ndash;          <span class="nav-item-span">{{ $t(`mobileMenuTitle.rewards`) }}</span>&ndash;&gt;-->
    <!--        &lt;!&ndash;        </div>&ndash;&gt;-->
    <!--        &lt;!&ndash;        <div class="mx-auto nav-wrapper">&ndash;&gt;-->
    <!--        &lt;!&ndash;          <v-card class="nav-item" :to="{ name: routeName.TRANSACTION_HISTORY }">&ndash;&gt;-->
    <!--        &lt;!&ndash;            <img class="img-nav-item" :src="`/static/svg/mobileMemberBalance/betHistory.svg`" />&ndash;&gt;-->
    <!--        &lt;!&ndash;          </v-card>&ndash;&gt;-->
    <!--        &lt;!&ndash;          <span class="nav-item-span">{{ $t(`mobileMenuTitle.betHistory`) }}</span>&ndash;&gt;-->
    <!--        &lt;!&ndash;        </div>&ndash;&gt;-->
    <!--        &lt;!&ndash;        <div class="mx-auto nav-wrapper">&ndash;&gt;-->
    <!--        &lt;!&ndash;          <v-card class="nav-item" :to="{ name: routeName.WITHDRAWAL }">&ndash;&gt;-->
    <!--        &lt;!&ndash;            <img class="img-nav-item" :src="`/static/svg/mobileMemberBalance/withdrawal.svg`" />&ndash;&gt;-->
    <!--        &lt;!&ndash;          </v-card>&ndash;&gt;-->
    <!--        &lt;!&ndash;          <span class="nav-item-span">{{ $t(`mobileMenuTitle.withdrawal`) }}</span>&ndash;&gt;-->
    <!--        &lt;!&ndash;        </div>&ndash;&gt;-->
    <!--        &lt;!&ndash;      </v-col>&ndash;&gt;-->
    <!--        &lt;!&ndash;  2nd draft design    &ndash;&gt;-->
    <!--        <v-col cols="3" class="MB-right-col d-flex align-center">-->
    <!--          <v-row class="justify-space-around">-->
    <!--            <v-avatar-->
    <!--              tile-->
    <!--              size="90"-->
    <!--            >-->
    <!--              <v-img v-if="memberVipTierProgress && memberVipTierProgress.image" :src="`${memberVipTierProgress.image}`"></v-img>-->
    <!--              <v-img v-else :src="`/static/svg/mobileAccount/vip_${tierColorThemeName}.svg`" eager></v-img>-->

    <!--            </v-avatar>-->
    <!--            &lt;!&ndash;          <div>&ndash;&gt;-->
    <!--            &lt;!&ndash;            viptiers badge&ndash;&gt;-->
    <!--            &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--          </v-row>-->
    <!--          <v-row>-->
    <!--            <span style="text-transform: uppercase;text-align: center">{{tierName}}</span>-->
    <!--          </v-row>-->
    <!--        </v-col>-->
    <!--      </v-row>-->
    <!--    </div>-->
    <!--    <div class="vip-benefits">-->
    <!--&lt;!&ndash;      <thead>&ndash;&gt;-->
    <!--&lt;!&ndash;      <tr>&ndash;&gt;-->
    <!--&lt;!&ndash;        <th>Game Type</th>&ndash;&gt;-->
    <!--&lt;!&ndash;        <th>Rebate Percentage</th>&ndash;&gt;-->
    <!--&lt;!&ndash;      </tr>&ndash;&gt;-->
    <!--&lt;!&ndash;      </thead>&ndash;&gt;-->
    <!--      <h2 style="font-size: 18px;">VIP Benefits</h2>-->
    <!--      <table style="width: 100%">-->
    <!--        <tbody>-->
    <!--        <tr>-->
    <!--          <td class="lefttext">Slots Rebate (%) </td>-->
    <!--          <td class="righttext">1.20%</td>-->
    <!--        </tr>-->
    <!--        <tr>-->
    <!--          <td class="lefttext">Live Casino  Rebate (%)</td>-->
    <!--          <td class="righttext">1.00%</td>-->
    <!--        </tr>-->
    <!--        <tr>-->
    <!--          <td class="lefttext">Sport  Rebate (%)</td>-->
    <!--          <td class="righttext">1.00%</td>-->
    <!--        </tr>-->
    <!--        </tbody>-->
    <!--      </table>-->
    <!--    </div>-->
    <!--    <div class="upgrade-requirement">-->
    <!--      <h2 style="font-size: 18px;">Tier Upgrade Requirement</h2>-->
    <!--      <table style="width: 100%">-->
    <!--        <tbody>-->
    <!--        <tr>-->
    <!--          <td class="lefttext">Upgrade Deposit Requirement (%) </td>-->
    <!--          <td class="righttext">Special Invitation</td>-->
    <!--        </tr>-->
    <!--        <tr>-->
    <!--          <td class="lefttext">Upgrade Turnover Requirement (%)</td>-->
    <!--          <td class="righttext">Special Invitation</td>-->
    <!--        </tr>-->
    <!--        <tr>-->
    <!--          <td class="lefttext">Upgrade Bonus (%)</td>-->
    <!--          <td class="righttext">168,888</td>-->
    <!--        </tr>-->
    <!--        </tbody>-->
    <!--      </table>-->
    <!--    </div>-->
    <!--    <div class="retention-requirement">-->
    <!--      <h2 style="font-size: 18px;">VIP Benefits</h2>-->
    <!--      <table style="width: 100%">-->
    <!--        <tbody>-->
    <!--        <tr>-->
    <!--          <td class="lefttext">Downgrade Criteria </td>-->
    <!--          <td class="righttext">Special Invitation</td>-->
    <!--        </tr>-->
    <!--        </tbody>-->
    <!--      </table>-->
    <!--    </div>-->
    <!--    <div class="be-nagad88-vip">-->
    <!--      <h1 style="    font-size: 18px;justify-content: center;display: flex; color: darkorange; padding-bottom: 20px; text-align: center;">Be A NAGAD88 VIP</h1>-->
    <!--      <p>Nagad88 is an online entertainment brand and a leading specialist of cricket exchange platform in Bangladesh.</p>-->
    <!--      <p>With over 100 games mixed with remarkable sromotions and 24/7 customer support services.</p>-->
    <!--      <p>There are multiple deposit payment methods for Bangladesh such as BKASH, ROCKET, NAGAD and many more to come. Be a Nagad88 VIP and enjoy generous benefits all time long!</p>-->
    <!--    </div>-->
    <!--    <div class="vip-level-upgrade-info">-->
    <!--      <h1 style="    font-size: 18px;color: darkorange; text-align: center; padding-bottom: 20px;">VIP LEVEL UPGRADE</h1>-->
    <!--      <p style=" color:orange; text-align: left;">How to Join?</p>-->

    <!--      <p>1. Every member will be starting from the Normal tier at the beginning.</p>-->
    <!--      <p>2 Members are required to fulfil the requirements stated in the table below in order to upgrade to a higher tier. For example, normal tier members who make a first time deposit and reach 5,000 turnover in the same month will be automatically upgraded to Bronze tier.</p>-->
    <!--      <p>3. Members tier of Gold, Platinum and Diamond will be downgraded it members are inactive for 3 months. Bronze and Silver tier will remain the same.</p>-->
    <!--      <p>4. The required deposit and turnover amount could not be accumulated to the next month, the requirement should be achieved in the same month in order to upgrade to a higher tier, otherwise the amount will be reset monthly.</p>-->
    <!--      <p>5. The rebate given is calculated based on daily turnover multiplied by rebate percentage. For example $5.000 turnover x 0.10% rebate in slot 5 rebate bonus.</p>-->
    <!--    </div>-->
    <!--    <div class="faq-tnc-container">-->
    <!--      <v-btn class="faqbtn" width="100%" @click="toggleFaq" color="primary"> <span>Frequently Asked Question</span>-->
    <!--        <div :class="['triangle', showFaq ? 'down' : 'up']"></div></v-btn>-->
    <!--      <v-expand-transition>-->
    <!--        <div v-if="showFaq">-->
    <!--          <p>1. This promotion is open for ALL REGISTERED MEMBER.</p>-->
    <!--          <p>2. All member offers are limited to once per person. Meaning one per family, household address, IP address, email address, telephone number, credit or debit card and/or e-payment account, or shared computer.</p>-->
    <!--          <p>3. Bonuses are valid for thirty (30) days upon issuance unless stated otherwise. Money won using bonus funds will be removed from the member's account if prerequisites are not fulfilled within the given time frame.</p>-->
    <!--          <p>4. Any bets resulting in void, tie, cancelled, or made on opposite sides with the same outcome or bets with odds less than DEC 1.5 or CN 0.5 will not be counted as a valid turnover. Turnover on all types of non-live table games(e.g. Blackjack, Video Poker, Craps, American Roulette, Baccarat, and other non-live table games) and non-slot games, will not count towards this turnover requirement unless SPECIFICALLY stated. Only 1/4 from your total bets will be counted as turnover for bets made on roulette.</p>-->
    <!--          <p>5. Participating members must accept and comply with all the terms mentioned above as well as all relevant rules and regulations stated on the Nagad88 website.</p>-->
    <!--          <p>6. Nagad88 reserves the right to modify, cancel, suspend or terminate the promotion and/or change the terms of the promotion at any time without prior notice.</p>-->
    <!--          <p>7. General Nagad88 Terms & Conditions apply.</p>-->
    <!--        </div>-->
    <!--      </v-expand-transition>-->
    <!--&lt;!&ndash;    </div>&ndash;&gt;-->
    <!--&lt;!&ndash;    <div class="tnc-container">&ndash;&gt;-->
    <!--      <v-btn class="tncbtn" width="100%" @click="toggleTnc" color="primary"> <span>Terms and Conditions </span>-->
    <!--        <div :class="['triangle', showTnc ? 'down' : 'up']"></div></v-btn>-->
    <!--      <v-expand-transition>-->
    <!--        <div v-if="showTnc">-->
    <!--          <p>1. This promotion is open for ALL REGISTERED MEMBER.</p>-->
    <!--          <p>2. All member offers are limited to once per person. Meaning one per family, household address, IP address, email address, telephone number, credit or debit card and/or e-payment account, or shared computer.</p>-->
    <!--          <p>3. Bonuses are valid for thirty (30) days upon issuance unless stated otherwise. Money won using bonus funds will be removed from the member's account if prerequisites are not fulfilled within the given time frame.</p>-->
    <!--          <p>4. Any bets resulting in void, tie, cancelled, or made on opposite sides with the same outcome or bets with odds less than DEC 1.5 or CN 0.5 will not be counted as a valid turnover. Turnover on all types of non-live table games(e.g. Blackjack, Video Poker, Craps, American Roulette, Baccarat, and other non-live table games) and non-slot games, will not count towards this turnover requirement unless SPECIFICALLY stated. Only 1/4 from your total bets will be counted as turnover for bets made on roulette.</p>-->
    <!--          <p>5. Participating members must accept and comply with all the terms mentioned above as well as all relevant rules and regulations stated on the Nagad88 website.</p>-->
    <!--          <p>6. Nagad88 reserves the right to modify, cancel, suspend or terminate the promotion and/or change the terms of the promotion at any time without prior notice.</p>-->
    <!--          <p>7. General Nagad88 Terms & Conditions apply.</p>-->
    <!--        </div>-->
    <!--      </v-expand-transition>-->
    <!--    </div>-->
  </div>
</template>

<script>
import VueQrCode from 'vue-qrcode-component'
import AppLoginEmbedded from '@/components/member/loginEmbedded.vue'
import { ROUTE_NAME } from '@/constants/route.constants'
import { uiHelper, locale, errorCodeHelper, formValidator } from '@/util'
import { SHARED } from '@/constants/constants'
import { REFERRAL_GET_OVERVIEW, REFERRAL_POST_COMMISSION, REFERRAL_RESET_COMMISSION, REFERRAL_GET_CONFIG } from '@/store/referral.module'
import stringFormat from 'string-format'
import currencySymbolMapp from 'currency-symbol-map'
import { MEMBER_WALLET, MEMBER_VIP_TIER_PROGRESS } from '@/store/member.module'
import { AFFILIATE_CLAIM_BONUS, AFFILIATE_DOWNLINE_DETAIL, AFFILIATE_DOWNLINE_LIST, AFFILIATE_UPLINE_REFERRAL } from '@/store/affiliate.bonus.module'

export default {
  name: 'referralSummary',
  components: {
    VueQrCode,
    AppLoginEmbedded
  },
  data: () => ({
    showReferralGuide: true,
    showFaq: false,
    showTnc: false,
    dateOfBirthMenu: false,
    stringFormat: stringFormat,
    currencySymbolMapp: currencySymbolMapp,
    language: uiHelper.getLanguage(),
    currentCurrency: uiHelper.getCurrency(),
    validator: formValidator,
    shared: SHARED,
    selectedTab: 'tier',
    dates: ['', ''],
    overview: {},
    redeemCommissionAmt: 0.0,
    share_url: '',
    alertShow: false,
    alertSuccess: false,
    alertMessage: '',

    notLoading: true,
    walletBalance: 0,
    routeName: ROUTE_NAME,
    showProgress: false
    // tierBarBgColor:'',
    // tierBarColor:'',
    // tierColorThemeName:'starter',
    // tierName:'',
    // currentProgressPercentage:0,
    // currentLv:0,
    // nextLv:0,
    // progressRequired:0,
  }),
  created() {
    this.getReferralOverview()
    this.getReferralConfig()
    this.getVipTierProgress()
    this.getMemberWallet()
    this.metaTag()
  },
  mounted() {
    this.$refs.redeemForm.reset()
    const script = document.createElement('script')
    script.src = 'https://fast.wistia.com/assets/external/E-v1.js'
    script.async = true
    document.body.appendChild(script)
  },
  computed: {
    downlineListPagination() {
      return this.$store.state.affiliateBonus.affiliateDownlineList.pagination
    },
    uplineReferral() {
      return this.$store.state.affiliateBonus.affiliateUplineReferral
    },
    downlineDetail() {
      return this.$store.state.affiliateBonus.affiliateDownlineDetail
    },
    imgSource() {
      return '/static/svg/mobileAccount/vip_' + this.tierColorThemeName + '.svg'
    },
    formattedValue() {
      const currencySymbol = this.currencySymbolMapp.currencySymbolMap[this.currentCurrency]
      const value = '10,000'
      return `${currencySymbol}${value}`
    },
    currentDate() {
      return new Date()
    },
    referralOverview() {
      return this.$store.state.referral.overview
    },

    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    totalPoint() {
      return this.overview.downline_lv1 + this.overview.downline_lv2 + this.overview.downline_lv3
    },
    redeemCommissionDetailResponseComplete() {
      return this.$store.state.referral.redeemCommissionResponse.complete
    },
    referralConfig() {
      return this.$store.state.referral.config
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    webShareApiSupported() {
      return navigator.share
    },
    memberVipTierProgress() {
      return this.$store.state.member.vipTierProgress.pairing
    },
    vipTierUpgrade() {
      return this.$store.state.member.vipTierProgress.upgrade
    },
    memberWallet() {
      return this.$store.state.member.walletBalance
    }
  },
  watch: {
    referralOverview() {
      this.overview = this.$store.state.referral.overview
      if (window.location.host.toLowerCase() === '8795158bn1.com') {
        this.share_url = 'https://nagad88.best' + '?refer_code=' + this.overview.my_referral_code
      } else {
        this.share_url = uiHelper.getHostname() + '?refer_code=' + this.overview.my_referral_code
      }
      this.redeemCommissionAmt = this.$store.state.referral.overview.commission_balance.toFixed(2)
    },
    redeemCommissionDetailResponseComplete() {
      let response = this.$store.state.referral.redeemCommissionResponse
      if (response.complete) {
        this.redeemCommissionResponseCompleteDialog(response)
        this.$store.dispatch(`${REFERRAL_RESET_COMMISSION}`)
      }
    },
    // memberVipTierProgress() {
    //   let vipTierProgress = this.$store.state.member.vipTierProgress
    //   if (Object.keys(vipTierProgress.pairing).length > 0) {
    //     let curPairing = vipTierProgress.pairing
    //     //progress found
    //     this.showProgress = true
    //     switch(curPairing.level_sequence){
    //       case 1:
    //         this.tierColorThemeName = 'bronze'
    //         break;
    //       case 2:
    //         this.tierColorThemeName = 'silver'
    //         break;
    //       case 3:
    //         this.tierColorThemeName = 'gold'
    //         break;
    //       default :
    //         this.tierColorThemeName = 'bronze'
    //         this.tierBarBgColor = '#1867c0'
    //
    //     }
    //     this.tierBarBgColor = 'viptier'+this.tierColorThemeName
    //     this.tierName = curPairing.name
    //     this.currentLv = this.memberVipTierProgress.level_sequence
    //     this.nextLv = this.memberVipTierProgress.level_sequence + 1
    //
    //
    //   } else {
    //     //no progress
    //     this.showProgress = false
    //   }
    // },
    isLoggedIn() {
      if (this.isLoggedIn) {
        this.getMemberWallet()
        this.getVipTierProgress()
      }
    },
    memberWallet() {
      this.notLoading = true
    }
  },
  methods: {
    closeShowReferralGuide() {
      this.showReferralGuide = false
    },
    redirectDownLineReport() {
      this.$router.push({
        name: ROUTE_NAME.REFERRAL_DOWNLINE_REPORT,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    metaTag() {
      // uiHelper.setMetaTag('url', 'https://www.nagad88.iom/en-BD/nagad88Ladderboard/challenge/')
      // uiHelper.setTitle(`${locale.getMessage('meta.challenge_title')}`)
      // uiHelper.setMetaTag('description', `${locale.getMessage('meta.challenge_description')}`)
      // uiHelper.setCanonical('https://www.nagad88.iom/en-BD/nagad88Ladderboard/challenge/')
      const currentUrl = window.location.href
      uiHelper.setCanonical(currentUrl)
      // uiHelper.setHreflangLinks('https://www.nagad88.iom/referral/summary')
      // uiHelper.setHreflangLinksen('https://www.nagad88.iom/en-BD/referral/summary')
      // uiHelper.setHreflangLinksbd('https://www.nagad88.iom/bn-BD/referral/summary')
      const domainWithProtocol = currentUrl.split('/')[2]
      const domain = domainWithProtocol.replace(/(^\w+:|^)\/\//, '')
      // const Links = `https://${domain}${window.location.pathname}`;
      // const Linksen = `https://${domain}/en-BD${window.location.pathname}`;
      // const Linksbn = `https://${domain}/bn-BD${window.location.pathname}`;
      const path = window.location.pathname
      const cleanPath = path.replace(/\/(en-BD|bn-BD)/i, '')
      const Links = `https://${domain}${cleanPath}`
      const Linksen = `https://${domain}/en-BD${cleanPath}`
      const Linksbn = `https://${domain}/bn-BD${cleanPath}`
      uiHelper.setHreflangLinks(Links)
      uiHelper.setHreflangLinksen(Linksen)
      uiHelper.setHreflangLinksbd(Linksbn)
    },
    getVipTierProgress() {
      this.$store.dispatch(MEMBER_VIP_TIER_PROGRESS)
    },
    affiliateClaimBonus() {
      this.$store.dispatch(`${AFFILIATE_CLAIM_BONUS}`)
    },
    getDownlineList() {
      let filter = {
        start_time: this.dates[0],
        end_time: this.dates[1],
        page: this.selectedPage,
        size: 10
      }
      this.$store.dispatch(`${AFFILIATE_DOWNLINE_LIST}`, { filter })
    },
    getUplineReferral() {
      this.$store.dispatch(`${AFFILIATE_UPLINE_REFERRAL}`)
    },
    decimalTruncate(num, fixed) {
      if (num == null) {
        num = 0
      }
      let re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?')
      return parseFloat(num.toString().match(re)[0])
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getMemberWallet() {
      this.notLoading = false
      this.$store.dispatch(MEMBER_WALLET)
    },
    toggleFaq() {
      this.showFaq = !this.showFaq
    },
    toggleTnc() {
      this.showTnc = !this.showTnc
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        console.log('Text copied to clipboard')
      })
    },
    // copyToClipboard(referralCode) {
    //   const textField = document.createElement('textarea')
    //   textField.innerText = referralCode
    //   document.body.appendChild(textField)
    //   textField.select()
    //   document.execCommand('copy')
    //   textField.remove()
    //   this.isCopied = true
    //   setTimeout(() => { this.isCopied = false }, 3000)
    // },
    getReferralConfig() {
      this.$store.dispatch(`${REFERRAL_GET_CONFIG}`)
    },
    getConfig(index) {
      let config = this.referralConfig.find(c => c.level == index)
      if (config) {
        return config.percentage
      } else {
        return 0
      }
    },
    openMsgDialog(selectedMsg) {
      this.msgDialog = {
        show: true,
        msg: selectedMsg.message,
        title: selectedMsg.subject
      }
    },
    closeMsgDialog() {
      this.msgDialog = {
        show: false
      }
    },
    getReferralOverview() {
      if (this.isLoggedIn) this.$store.dispatch(`${REFERRAL_GET_OVERVIEW}`)
    },
    redeemCommissionConfirmationDialog() {
      let self = this
      if (this.$refs.redeemForm.validate()) {
        let dialog = this.initializePageDialogProperty()
        dialog.title = locale.getMessage(`label.redeemConfirmation`)
        dialog.message.push(this.stringFormat(locale.getMessage(`message.ConfirmCommission`), self.$options.filters.currency(this.redeemCommissionAmt, this.currentCurrency)))
        dialog.button.push({
          title: locale.getMessage(`label.confirm`),
          action: () => this.redeemCommission()
        })
        this.openPageDialog(dialog)
      }
    },
    redeemCommission() {
      let obj = { amount: this.redeemCommissionAmt }
      this.$store.dispatch(`${REFERRAL_POST_COMMISSION}`, {
        obj
      })
    },
    redeemCommissionResponseCompleteDialog(response) {
      this.closePageDialog()
      if (response.code != 0 && !response.success) {
        this.$parent.$parent.openAlert(false, errorCodeHelper.getErrorCodeDesc(response.code))
      } else {
        this.$parent.$parent.openAlert(true, locale.getMessage(`message.commissionRedeemSuccess`))
      }
    },
    initializePageDialogProperty() {
      let initPageDialog = {
        title: locale.getMessage(`label.system`),
        dialogXButton: this.closePageDialog,
        messageTitle: '',
        message: [],
        button: []
      }
      return initPageDialog
    },
    openPageDialog(dialog) {
      this.$eventHub.$emit('open-page-dialog', dialog)
    },
    closePageDialog() {
      this.$eventHub.$emit('close-page-dialog', true)
    },
    share() {
      const sharing = {
        title: locale.getMessage(`message.referralShareTitle`),
        text: locale.getMessage(`message.referralShareMsg`),
        url: this.share_url
      }
      if (this.webShareApiSupported) {
        navigator.share(sharing)
      } else {
        let $f = this
        this.$copyText(this.share_url).then(function(e) {
          $f.alertMessage = 'Referral Link Copied!'
          $f.alertSuccess = true
          $f.alertShow = true
        })
      }
    }
  }
}
</script>

<style lang="scss">
.referralGuideText {
  font-size: 12px;
}
.commissionContentHeight {
  height: 60%;
}
.referralGuideSection {
  display: flex;
  align-items: center;
  padding: 12px;
  background: #e2e2e2;
  margin-bottom: 8px !important;
  height: fit-content;
}

.video-section {
  padding: 0 12px;
  margin-top: 0;
  margin-bottom: 8px;
  display: block;
  height: 24%;

  @media screen and (max-width: 599px) {
    height: auto;
  }
}

.commission-content-card {
  height: 250px;
  max-width: 100% !important;
}
.border-referralbonus {
  border: 2px solid #222ce2;
  border-radius: 10px;
}
.tier-container-box {
  padding: 20px !important;
  background: #e3e3e3;
  border-radius: 0px 10px 10px 0px;
}
.redeem-textarea .v-input__control .v-input__slot {
  margin-bottom: 0px;
  border-radius: 5px;
  min-height: 20px;
  .v-input__append-inner {
    justify-content: center;
    align-items: center;
    margin: auto;
  }
}
.custom-divider-bottom {
  color: white;
  border-color: white !important;
  border-bottom: 1px solid;
  margin-top: 10px;
  margin-bottom: 10px;
}
.customized-icon-position {
  display: flex;
  padding: 0px;
  align-items: end;
  height: 55px;
}
.vip-level-upgrade-info p,
.be-nagad88-vip p {
  font-size: 11px;
}
.blue-text {
  color: #0047ff;
}
//#input-828 {
//  color: black !important;
//}
//.theme--light.v-input--is-disabled input.redeem-textarea,
//.theme--light.v-input--is-disabled textarea.redeem-textarea {
//  color: black !important;
//}
.redeem-textarea .v-input__slot {
  background: #9b9b9b !important;
  color: #020e2e !important;
  font-weight: bolder;
}

.show-copyreferral input {
  color: #0047ff !important;
  font: 18px/27px Poppins;
  font-weight: bolder !important;
}

.redeem-textarea input {
  color: #020e2e !important;
}

.redeem-textarea .v-input--is-disabled_textarea {
  color: white !important;
  font-weight: bolder;
}
.amount-textarea .v-text-field__prefix {
  color: #9b9b9b !important;
}

.redeem-textarea .v-text-field__prefix {
  color: #020e2e !important;
  //font-weight: bolder;
}

.border-left-radius {
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.border-right-radius {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
}

.commission-redeem-field {
  input {
    text-align: right;
  }

  .v-input__slot {
    background-color: #fff !important;
  }
}

.media-btn {
  height: 50px;
  width: 100px;
}

.commission-content-holder {
  border-radius: 0px !important;

  .qrCode > img {
    border: 0px;
    padding: 0px;
    margin: auto;
    width: 230px;
    height: 230px;
  }

  .dialog-button {
    color: var(--v-text_reverse-base);
    background: transparent linear-gradient(180deg, #ffab2d 0%, #ff7700 100%) 0% 0% no-repeat padding-box !important;
    width: 100%;
  }
}

.v-btn.theme-button {
  // background: #FDDD04;
  text-transform: capitalize;
  border-radius: 10px;
  height: auto;
  font-size: 16px;
}
.referral-tier .primary.text-center.tier-container.v-card.v-sheet.theme--light {
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
//.referral-tier .

.referral-tier {
  .tier-head {
    position: relative;
    display: flex;
    justify-content: center;

    .tier-info {
      position: absolute;
      bottom: 30px;
      right: -25px;
      cursor: pointer;
    }
  }

  .tier-container {
    margin: auto;
    max-width: 250px;
    margin-bottom: 20px;
  }

  .tier-tool-tip {
    color: #ffffff;
    .tier-tool-tip-icon {
      background-color: #ffffff;
      mask: url(/static/image/referral/referral-info.svg);
      mask-repeat: no-repeat;
      mask-position: center;
      -webkit-mask: url(/static/image/referral/referral-info.svg);
      -webkit-mask-repeat: no-repeat;
      -webkit-mask-position: center;
      cursor: pointer;
    }
  }

  .detail {
    color: white;
  }

  .mobile-carousel {
    height: 350px !important;
  }
}

@media screen and (min-width: 1220px) {
  .padding-left {
    padding-left: 35px !important;
  }
}
@media screen and (max-width: 1250px) {
  .avatar-size {
    width: 70px !important;
  }
  .referral-tier .tier-head .tier-info {
    right: 10px;
  }
  .commission-content-holder {
    .qrCode > img {
      width: 200px;
      height: auto;
    }
  }
}
@media screen and (max-width: 900px) {
  .commission-content-holder {
    .qrCode > img {
      width: 165px;
      height: auto;
    }
  }
  .avatar-size {
    width: 50px !important;
  }
  .text--style {
    font-size: 13px !important;
  }
}
@media screen and (max-width: 750px) {
  .commission-content-holder {
    .qrCode > img {
      width: 125px;
      height: auto;
    }
  }
  .text--style {
    font-size: 11px !important;
  }
}
@media (min-width: 599px) {
  .referralGuideSection {
    height: 11%;
  }
}

@media (min-width: 2100px) {
  .referralGuideSection {
    height: 7%;
  }

  .commissionContentHeight {
    height: 47%;
  }

  .video-section {
    height: 40%;
  }
}
@media (min-width: 1499px) and (max-width: 2099px) {
  .referralGuideSection {
    height: 8%;
  }

  .commissionContentHeight {
    height: 55%;
  }

  .video-section {
    height: 33%;
  }
}
@media (min-width: 860px) and (max-width: 1099px) {
  .referralText,
  .referralGuideSection {
    font-size: 12px;
  }
  .referralGuideSection {
    height: 13%;
  }
  .commissionContentHeight {
    height: 62%;
  }
  .video-section {
    height: 20%;
  }
}
@media (min-width: 730px) and (max-width: 859px) {
  .referralText,
  .referralGuideSection {
    font-size: 10px;
  }
  .referralGuideSection {
    height: 15%;
  }
  .commissionContentHeight {
    height: 65.5%;
  }
  .video-section {
    height: 17%;
  }
}
@media (min-width: 599px) and (max-width: 729px) {
  .referralText,
  .referralGuideSection {
    font-size: 9px;
  }
  .referralGuideSection {
    height: 15%;
  }
  .commissionContentHeight {
    height: 64.5%;
  }
  .video-section {
    height: 18%;
  }
}
</style>
